var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", { attrs: { hideable: true } }, [
    _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
      _c("i", { staticClass: "fas fa-microphone" }),
      _vm._v(
        " " +
          _vm._s(_vm.resource("AnalysisSelection_Index_Calls_Header")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
      _c("div", { staticClass: "grid-container calls" }, [
        _c("div", { staticClass: "grid-item-bottom-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: _vm.analysisDisabled },
              on: {
                click: function($event) {
                  return _vm.processCalls()
                }
              }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "AnalysisSelection_Index_SelectCalls_Button_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "grid-item-calls-table" },
          [
            _c("DataTable", {
              staticClass: "table table-striped",
              attrs: {
                columns: _vm.columns,
                data: _vm.enrichedValue,
                loading: _vm.loading,
                datatableOptions: _vm.datatableOptions,
                options: _vm.options
              },
              on: {
                selected: function($event) {
                  return _vm.addCall($event)
                },
                unselected: function($event) {
                  return _vm.removeCall($event)
                },
                "select-all": function($event) {
                  return _vm.selectAll($event)
                },
                "unselect-all": function($event) {
                  return _vm.unselectAll($event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid-item-bottom-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: _vm.analysisDisabled },
              on: {
                click: function($event) {
                  return _vm.processCalls()
                }
              }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "AnalysisSelection_Index_SelectCalls_Button_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }